import React from 'react';
import { styled } from '@mui/system';
import { getLanguage } from 'translation';
import LinkIcon from 'assets/icons/link.svg?react';

const StyledList = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  fontFamily: 'Rubik-Regular',
  color: 'rgba(34, 34, 34, 0.8)',
  counterReset: 'li-count',
  position: 'relative',
  '& li': {
    fontSize: 16,
    lineHeight: '20.7px',
    marginBottom: 25,
    counterIncrement: 'li-count',
    justifyContent: 'flex-start',
    alignItems: 'center',
    display: 'flex',
    position: 'relative',
    paddingLeft: '60px',
    minHeight: 40,
    '&::before': {
      content: 'counter( li-count)',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.white.main,
      width: 40,
      height: 40,
      marginRight: 20,
      fontSize: 30,
      lineHeight: '45px',
      borderRadius: 8,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      left: 0,
      minHeight: 'unset'
    }
  }
}));

const LinkIconStyled = styled(LinkIcon)(() => ({
  width: 15,
  height: 27,
  position: 'absolute',
  left: 0,
  transform: 'rotate(-45deg)'
}));

const ArrowedList = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  fontFamily: 'Rubik-Regular',
  marginBottom: 35,
  '& li': {
    display: 'flex',
    alignItems: 'center',
    fontSize: 18,
    color: theme.palette.textPrimary.main,
    marginBottom: 18,
    position: 'relative',
    paddingLeft: 40
  }
}));

const StyledListWrapper = ({ list, variant, getText }) => {
  const [lang] = React.useState(() => getLanguage().toUpperCase());

  if (variant === 'arrow') {
    return (
      <ArrowedList>
        {(list || []).map((item) => {
          const text = item[`name${lang}`] || item.bioDescription;

          if (!text) return null;

          return (
            <li key={item?._id}>
              <LinkIconStyled />
              {text}
            </li>
          );
        })}
      </ArrowedList>
    );
  }

  return (
    <StyledList>
      {(list || []).map((item) => {
        const text = getText ? getText(item) : item[`name${lang}`] || item?.advantageDescription;
        if (!text) return null;
        return <li key={item?._id || text}>{text}</li>;
      })}
    </StyledList>
  );
};

export default StyledListWrapper;
